var React = require('react');

function Caldeira (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"d":"M0 0l20.928 4.057 4.303 6.409v8.782h3.27l11.125 11.467h6.288l28.78 36.428 1.604 12.181 8.695 10.07 22.277 11.569 11.431-12.489 25.89 8.426 31.49-18.706 36.813 20.648 13.391 17.273 4.753 33.983 12.609 48.613-10.955 55.998 4.376 38.678 9.046 30.087V419l-33.22 80.5-53.894 30c-38.886 11.798-66.988 21.132-84.306 28C57.377 564.368 32.478 576.535 0 594V0zm192.668 95.368l-5.709 13.504-18.285 2.03-8.576 8.546-10.544-1.145-4.507-7.4L112 105.308l2.165 10.581 16.421 15.068 29.512 7.728 19.328 15.235 7.533 9.13 14.12 3.35 5.354-7.254v-23.007l3.722-2.825-1.313-12.812 3.445-4.613-14.34-19.06-5.28-1.46z","id":"a"})),React.createElement("use",{"fill":"#000","xlinkHref":"#a","fillRule":"evenodd","key":1})]);
}

Caldeira.defaultProps = {"width":"247","height":"594","viewBox":"0 0 247 594"};

module.exports = Caldeira;

Caldeira.default = Caldeira;
